import { HStack, Text, TextProps } from "@chakra-ui/react";
import { CurrentActiveUserInterface } from "../../constants/User";
import { Link } from "react-router-dom";
import { useBgHover } from "../../themes/colors";

interface Props extends TextProps {
  user: CurrentActiveUserInterface;
}

export const LoginText = ({ user, ...rest }: Props) => {
  const bgHover = useBgHover();

  return (
    <HStack
      as={Link}
      to={
        user?.role === "buyer"
          ? "/login"
          : user?.role === "reseller"
          ? "/login?type=reseller"
          : "/login?type=supplier"
      }
      borderRadius={"md"}
      p={1}
      _hover={{ bg: bgHover }}
    >
      <Text
        display={"block"}
        textStyle={"b-sm-sb"}
        fontWeight={500}
        py={1}
        {...rest}
      >
        Login Akun&nbsp;
        {user?.role === "buyer"
          ? "Pembeli"
          : user?.role === "supplier"
          ? "Supplier"
          : "Reseller"}
      </Text>
    </HStack>
  );
};
